import type { Matter } from "@/shared/cache/slices/matters";

export function findClientForMatterId(
	matterId: unknown,
	matters: Matter[],
): string | null {
	if (!matterId) return null;
	return (
		matters.find((matter) => matter.matter_id === String(matterId))?.client ??
		null
	);
}
